import axios, { AxiosInstance } from 'axios';
import { useUserStore } from '../store/user-store';
import { HTTP_STATUS } from './api-response-status';

export const BASE_URL = 'https://apiacad.moztaservicos.com';

// export const BASE_URL = 'http://localhost:3020';
export const GOOGLE_API_KEY = 'AIzaSyB5v8QIe5AcXYGeGwZuGUcnZh_21ZyBHxM';

const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 25000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getApiPhoto = (id: string): string => {
  return `${BASE_URL}/api/file/` + id;
};

apiClient.interceptors.request.use(
  (config) => {
    const token = useUserStore.getState().getToken();
    if (token) {
      config.headers.Authorization = `Basic ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - token expired or invalid
    if (error.response?.status === 401) {
      useUserStore.getState().clearUser();
      window.location.href = '/login';
    }

    if (error.response) {
      const axiosError = new axios.AxiosError(
        error?.message,
        error?.code,
        error?.config,
        error?.request,
        error?.response
      );
      return Promise.reject(axiosError);
    } else if (error.request) {
      // No response received from server | Network error
      const axiosError = new axios.AxiosError(
        error?.message,
        error?.code,
        error?.config,
        error?.request,
        {
          status: 400,
          data: {
            status: HTTP_STATUS.NETWORK_ERROR,
          },
        } as any
      );
      return Promise.reject(axiosError);
    } else {
      const axiosError = new axios.AxiosError(
        error?.message,
        error?.code,
        error?.config,
        error?.request,
        {
          status: 400,
          data: {
            status: HTTP_STATUS.UNEXPECTED_ERROR,
          },
        } as any
      );
      return Promise.reject(axiosError);
    }
  }
);

export default apiClient;
